import React from 'react';
import { useIsComerciales } from 'src/feature-app/hooks';
import { Apellido, InputGroupWrapper, Nombre, Trato } from '.';

export const NombreApellidos = () => {
	const isComerciales = useIsComerciales();

	return (
		<InputGroupWrapper className="nombre-apellidos-wrapper">
			{isComerciales ? <Trato /> : null}
			<Nombre />
			<Apellido name="surname" label="Primer apellido" required={true} />
			<Apellido
				name="secondSurname"
				label="Segundo apellido"
				required={false}
			/>
		</InputGroupWrapper>
	);
};
